import React, { Suspense } from 'react';

import FullscreenLoader from '../components/FullscreenLoader';

interface ISuspenseRouteProps {
  children: React.ReactNode;
}

export default function SuspenseRoute({ children }: ISuspenseRouteProps) {
  return <Suspense fallback={<FullscreenLoader />}>{children}</Suspense>;
}
